import moment from "moment";
import modelBaseV2 from "../model-base-v2.model";
// import { formats } from "../../config/constants";

const SiteSoldToShipToSpecialModel = {
    searchSiteSpecialMapping: (body) => {
        return modelBaseV2.post('/api/site-special-mapping/search', { body });
    },
    deleteSiteSpecialMapping: (body) => {
        return modelBaseV2.post('/api/site-special-mapping/delete', { body });
    },
    downloadSiteSpecialMappingExcel: (body) => {
        return modelBaseV2.postDownload('/api/site-special-mapping/excel-download', { body },`RepSoldToMapping_${moment().format('YYYYMMDDhhmm')}.xlsx`);
    },
    searchRepresentativeShipTo: (searchTerm) => {
        const queryString = modelBaseV2.toQueryString({ search: searchTerm});
        return modelBaseV2.get(`/api/representative-shipto/list?${queryString}`, {}, true)
    },
    updateRepresentativeShipTo: (body) => {
        return modelBaseV2.post('/api/site-special-mapping/update', { body })
    },
    uploadExcel: (file) => {
        let body = new FormData();
        body.append("uploadedExcel", file, file.name);
    
        return modelBaseV2.post('/api/site-special-mapping/excel-upload', { body });
    }
}

export default SiteSoldToShipToSpecialModel;  